import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { IPhotographerInvoice } from '../photographer/SinglePhotographerInvoiceTypes';
import { Row, Col } from 'react-bootstrap';

interface IProps {
    invoice: IPhotographerInvoice;
    key: number;
    view: (invoice: IPhotographerInvoice) => void;
}

const RejectedInvoiceListRow = (props: IProps) => {
    return (
        <Row>
            <Col sm={12} md={6}>
                <div>{props.invoice.photographerName}</div>
            </Col>
            <Col sm={12} md={6}>
                <a onClick={() => props.view(props.invoice)}>{props.invoice.name}</a>
            </Col>
        </Row>
    );
};

export default RejectedInvoiceListRow;
